import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { OrderItemLogApi } from 'api';

export const findOrderItemLog = createAsyncThunk(
  'orderItemLogSlice/findOrderItemLog',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await OrderItemLogApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const orderItemLogSlice = createSlice({
  name: 'orderItemLog',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findOrderItemLog.fulfilled, (state, action) => {
      const { data } = action.payload;
      const newData = data.map(item => {
        return {
          key: item.id,
          ...item,
        };
      });
      state.list = newData;
    });
  },
});

const { reducer: orderItemLogReducer } = orderItemLogSlice;

export default orderItemLogReducer;
